import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyHighlightLinks(enabled) {
  toggleHtmlClass(CLASSES.highlightLinks, enabled);
}

export function applyHighlightHeadings(enabled) {
  toggleHtmlClass(CLASSES.highlightHeadings, enabled);
}
